<div class="move-floor-container">
  <p>{{ 'moreInfo.moveThisFloor' | xTranslate }}</p>
  <form [formGroup]="moveFloorFG" class="floors-wrapper">
    <mat-form-field class="mat-select-field mat-form-field" floatLabel="never" appearance="outline">
      <mat-select
        hideSingleSelectionIndicator="true"
        [placeholder]="'commonLabels.select' | xTranslate"
        panelClass="custom-dropdown"
        name="aboveBelow"
        formControlName="aboveBelow"
      >
        <mat-option *ngFor="let position of aboveBelowOptions" [value]="position.value">
          {{ position.label | xTranslate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="mat-select-field mat-form-field" floatLabel="never" appearance="outline">
      <mat-select
        hideSingleSelectionIndicator="true"
        [placeholder]="'commonLabels.select' | xTranslate"
        panelClass="custom-dropdown"
        name="floorIndex"
        formControlName="floorIndex"
      >
        <mat-option *ngFor="let floor of data" [value]="floor.value">
          {{ floor.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  <button mat-flat-button color="primary" type="submit" (click)="moveFloor()">
    {{ 'commonLabels.move' | xTranslate }}
  </button>
</div>
